"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_USES = exports.USE_CLASSES = exports.SIZE_CLASSES = void 0;
var SIZE_CLASSES = {
  default: 'private-button--default',
  sm: 'private-button--sm',
  xs: 'private-button--xs',
  md: 'private-button--default'
};
exports.SIZE_CLASSES = SIZE_CLASSES;
var USE_CLASSES = {
  danger: 'private-button--destructive',
  link: 'private-button__link',
  'link-danger': 'private-button__link private-button__link--danger',
  'link-on-dark': 'private-button__link private-button__link--on-dark',
  'link-on-bright': 'private-button__link private-button__link--on-bright',
  primary: 'private-button--primary',
  'primary-white': 'private-button--primary--white',
  secondary: 'private-button--secondary',
  'secondary-ghost': 'private-button--secondary--ghost',
  tertiary: 'private-button--tertiary',
  'tertiary-light': 'private-button--tertiary-light',
  'tertiary-extra-light': 'private-button--tertiary-extra-light',
  transparent: 'private-button--transparent',
  unstyled: 'private-button--unstyled',
  form: 'private-button--form private-form__control',
  'form-on-dark': 'private-button--form private-form__control private-button--form--on-dark'
};
exports.USE_CLASSES = USE_CLASSES;
var LINK_USES = ['link', 'link-danger', 'link-on-dark'];
exports.LINK_USES = LINK_USES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/button/ButtonConstants.js
// module id = 328
// module chunks = 209 210 211 212